import processInclude from "base/util";
import detail from "./product/detail";
import wishlist from "./product/wishlist";

$(document).ready(() => {
    processInclude(detail);
    processInclude(wishlist);
});
